// extracted by mini-css-extract-plugin
module.exports = {"btnFacebook":"social_btnFacebook__CP_Tm","btnGoogle":"social_btnGoogle__vrE0e","btnApple":"social_btnApple__mF1cA"};